export const getPolicies = ({ policyReducer: { policies = [] } = {} }) =>
  policies;
export const getPoliciesFilter = ({ policyReducer: { filter = {} } = {} }) =>
  filter;
  export const getPoliciesCount = ({ policyReducer: { count = 0 } = {} }) => count;
